import { LowerCasePipe, NgClass, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IMultisiteItem, MultisiteService } from '@df/core/service/multisite';
import { DfUiModule } from '@df/ui/df-ui.module';
import { MultisiteFlagComponent } from '../flag/multisite-flag.component';
import { TradeClassDirective } from '../trade/trade-class.directive';
@Component({
    selector: 'multisite-label',
    templateUrl: './multisite-label.component.html',
    standalone: true,
    imports: [MultisiteFlagComponent, NgClass, DfUiModule, LowerCasePipe, TradeClassDirective, UpperCasePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteLabelComponent implements OnInit {
    @Input()
    isFooter: boolean;
    constructor(readonly multisiteService: MultisiteService) {}
    site: IMultisiteItem;
    ngOnInit(): void {
        this.site = this.multisiteService.current;
    }
}
